import { Browser } from "../../core/browser";
import { Dialog } from "../../dialog/dialog";
import { AuxiliumComponent } from "../auxilium-component";

export default class Card extends AuxiliumComponent {
	static observable = ["image", "video", "link", "audio", "variation", "size", "heading", "heading-size", "subtitle"];
	static observableBooleans = ["scroll", "flush", "hoverable", "hide-blur", "table-card", "allow-preview", "flush-header"];

	constructor() {
		super();

		this.headingSize ??= (() => {
			switch (this.size) {
				case "xs": return "5";
				case "sm": return "4";
				case "md": return "2";
				case "lg": return "1";
				case "body": return "body";
				default: return "3";
			}
		})();
	}

	setBody(content) {
		const bodyElement = this.querySelector(".card-body") ?? this.appendChild(document.createElementWithContents("div", null, { className: "card-body" }));

		bodyElement.innerHTML = content;
	}

	attributeChanged(name, _, newValue) {
		if (name === "hide-blur" && this.IsAttributeValueTrue(newValue)) {
			this.querySelector(":scope > * > .card-header img + img")?.remove();
		}
	}

	parsedCallback() {
		this.classList.add("card-frame");

		if (this.image || this.video || this.audio) {
			this.querySelector(":scope>.card-header,:scope> chip-cardheader")?.remove();
		}

		if (this.image) {
			const loader = document.createElementWithContents("chip-loading", null, { type: "image", size: "xxxxl" });

			function imgLoaded(ev) {
				loader.remove();
				ev.target.classList.add("image--loaded");
			}

			const img = document.createElementWithContents("img", null, {
				loading: "lazy",
				src: this.image,
				onload: ev => imgLoaded(ev),
				alt: "Card Image Preview"
			}), visibleImg = !this.hideBlur ? img.cloneNode() : null;

			if (visibleImg) { visibleImg.onload = ev => imgLoaded(ev); }

			this.prepend(document.createElementWithContents("chip-cardheader", [loader, img, visibleImg], {
				onclick: () => this.allowPreview ? Dialog.ShowImage(this.image) : null
			}));
		}

		if (this.video) {
			const vid = document.createElementWithContents("video", `<source src="${this.video}"></source>`, {
				controls: true
			});

			this.prepend(document.createElementWithContents("chip-cardheader", vid));
		}

		if (this.audio) {
			const ado = document.createElementWithContents("audio", null, {
				controls: true,
				src: this.audio
			});

			this.prepend(document.createElementWithContents("chip-cardheader", ado));
		}

		const card = document.createElementWithContents(this.link ? "a" : "div",
			this.heading ?
				`
				<div class="card-header">
					<chip-header>${this.heading}</chip-header>
					<div class="card-subtitle">${this.subtitle}</div>
				</div>
			`.trim() : document.createElementWithContents("div", this.querySelector(":scope>chip-cardheader"), { className: "card-header" })
		), header = card.querySelector("chip-cardheader");

		if (this.link) { card.href = Browser.ResolveRelativeURL(this.link); }

		if (!header) {
			if (!this.heading) { card.querySelector(".card-title")?.remove(); }
			else { card.querySelector(".card-header>chip-header:first-child").size = this.headingSize; }

			if (!this.subtitle) { card.querySelector(".card-subtitle")?.remove(); }
			if (!this.heading && !this.subtitle) { card.querySelector(".card-header").remove(); }
		} else {
			header.addEventListener("click", () => this.raiseEvent("headerclick"));
		}

		if (this.innerHTML.trim() !== "") {
			card.appendChild(document.createElementWithContents("div", this.childNodes, { className: "card-body" }));
		}

		this.append(card);
	}
}
